import { useHead } from '@unhead/react';
import { useTranslation } from 'translations/hooks';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useAppContext } from 'business/contextProviders/useAppContext';
import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { ExcavationBuildTimeGraphContainer } from 'business/production-and-performance/pages/excavation-build-time/components/excavation-build-time-graph-container';
import { LegendFilterProvider } from 'business/production-and-performance/pages/excavation-build-time/providers/legend-filter';
import { ProdAndPerfFiltersProvider } from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { SingleGraphReferenceContextProvider } from 'business/providers/graph-reference';
import { Module_Enum, useGetCurrentRingQuery } from 'generated/graphql';
import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';
import Loader from 'ui/loader';

import { ExcavationBuildTimeMobileFilters } from './excavation-build-time-mobile-filters';

export const ExcavationBuildTimeMobilePage = () => {
  const { t } = useTranslation();

  useHead({
    title: t('user.menu.sections.prodPerf.excavationBuildTime.title'),
  });

  const graphqlHeaders = useGraphqlApiHeaders(Module_Enum.DataAnalysis);
  const { currentConstructionSiteId } = useAppContext();
  const { data, loading } = useGetCurrentRingQuery({
    variables: { constructionSiteId: currentConstructionSiteId },
    context: { headers: graphqlHeaders },
  });
  const lastRing = data?.parameter_ring_aggregate.aggregate?.max?.ringNumber;

  return (
    <SingleGraphReferenceContextProvider>
      {loading ? (
        <Loader />
      ) : (
        <ProdAndPerfFiltersProvider
          initialFilters={{
            filterType: 'ring',
            ringRange: isUndefinedOrNull(lastRing)
              ? [null, null]
              : [lastRing - 50, lastRing],
            dayMode: 'calendar',
            showTotalDurations: false,
          }}
        >
          <LegendFilterProvider>
            <MobileSingleCardPageWithFilterLayout
              title={t('productionAndPerformance.excavationBuildTime.title')}
              filters={<ExcavationBuildTimeMobileFilters />}
            >
              <ExcavationBuildTimeGraphContainer />
            </MobileSingleCardPageWithFilterLayout>
          </LegendFilterProvider>
        </ProdAndPerfFiltersProvider>
      )}
    </SingleGraphReferenceContextProvider>
  );
};
